export enum EDeleteCasesState {
    Waiting = 0,
    InProgress = 1,
    Failed = 2,
    Succeeded = 3
}